import PropTypes from 'prop-types';
import SVGInline from 'react-svg-inline';
import IconButton from 'legacy/components/generic/IconButton';
import SimpleLoader from 'legacy/components/generic/SimpleLoader';

import share from 'legacy/assets/svg-inline/share.svg';

const ShareReportButton = ({
  uniqueLinkDoesNotExist,
  reportStatus,
  isLoading,
  disabled,
  handleClickShare,
  label
}) => {
  return (
    <IconButton
      dataHcName="valuation-share-button"
      mini
      disabled={disabled || isLoading}
      onClick={handleClickShare}
      label="Share"
      icon={
        <div>
          {disabled || isLoading ? (
            <SimpleLoader />
          ) : (
            <div style={{ textAlign: 'center' }}>
              <SVGInline height="30px" width="30px" svg={share} />
            </div>
          )}
        </div>
      }
    />
  );
};

ShareReportButton.defaultProps = {
  reportStatus: 'expired'
};

ShareReportButton.propTypes = {
  handleClickShare: PropTypes.func.isRequired,

  uniqueLinkDoesNotExist: PropTypes.bool,
  isLoading: PropTypes.bool,
  disabled: PropTypes.bool,
  reportStatus: PropTypes.string
};

export default ShareReportButton;
